import dynamic from 'next/dynamic';

import { ContentCardVariant } from '@/components/organisms';

import {
  WIDGET_TYPES as TYPES,
  WIDGET_TEMPLATES as TEMPLATES,
} from './constants';
import {
  CardDataType,
  CardVariations,
  ContentTypeVariations,
} from '../CardCarousel/types';

import type { WidgetPlugin } from './types';

type CardCarouselProps = {
  items: CardDataType[];
  variant: 'default' | 'fade' | 'cube' | 'coverflow';
  title: string;
  showAllURL?: string;
};

export const CategorizedCarouselListPlugin: WidgetPlugin<CardCarouselProps> = {
  type: TYPES.CONTENT_SELECTION,
  template: TEMPLATES.CAROUSEL,
  component: dynamic(() =>
    import('@/components/organisms/CardCarousel').then(mod => mod.CardCarousel),
  ),
  mapProps: widget => {
    return {
      items:
        widget.template.items?.map(item => ({
          variant: ContentCardVariant.BASIC,
          title: item.title,
          description: item.short_description,
          imageUrl: item.art_work?.url || item.art_work?.path || '',
          id: item.id,
          type: CardVariations.BASIC,
          contentType: widget.content_parameters
            .content_type as ContentTypeVariations,
        })) || [],
      variant: 'default',
      title: widget.title as string,
      ...(widget.template.configuration?.view_all === true
        ? { showAllURL: `?seeAll&widgetId=${widget.id}` }
        : {}),
    };
  },
};

export const UncategorizedCarouselListPlugin: WidgetPlugin<CardCarouselProps> =
  {
    type: TYPES.UNCATEGORIZED_CUSTOMER_GROUP_CONTENT,
    template: TEMPLATES.CAROUSEL,
    component: dynamic(() =>
      import('@/components/organisms/CardCarousel').then(
        mod => mod.CardCarousel,
      ),
    ),
    mapProps: widget => {
      return {
        items:
          widget.template.items?.map(item => ({
            variant: ContentCardVariant.BASIC,
            title: item.title,
            description: item.short_description,
            imageUrl: item.art_work?.url || item.art_work?.path || '',
            id: item.id,
            type: CardVariations.BASIC,
            contentType: widget.content_parameters
              .content_type as ContentTypeVariations,
          })) || [],
        variant: 'default',
        title: widget.title,
        widgetId: widget.id,
        ...(widget.template.configuration?.view_all === true
          ? { showAllURL: `?seeAll&widgetId=${widget.id}` }
          : {}),
      };
    },
  };
